// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commonLink[data-v-536b6995]{color:#9C87FB;width:fit-content}.commonLink[data-v-536b6995]:hover{color:#fff;background-color:#9C87FB}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
